import { Information } from '@mint-lib/icons';
import {
  Card,
  FeaturedIcon,
  typographyVariants,
} from '@mint-lib/tw-components';

function AppliedRouteComponent() {
  return (
    <Card
      hover={'noHover'}
      className="flex h-[50vh] w-212.5 items-center justify-center overflow-hidden px-13"
      contentClassName="p-0"
    >
      <div className={'flex flex-col items-center justify-center gap-8'}>
        <div className={'flex flex-col items-center justify-center gap-4'}>
          <FeaturedIcon icon={<Information />} className={'h-16 w-16'} />
          <h2
            className={typographyVariants({ variant: 'h2', color: 'primary' })}
          >
            Changes already applied
          </h2>
        </div>
        <p
          className={typographyVariants({
            variant: 'bodyLong02',
            color: 'secondary',
          })}
        >
          It looks like someone else already confirmed the budget changes.
        </p>
      </div>
    </Card>
  );
}

export default AppliedRouteComponent;
